/**
 * Driver Campaigns API - FleetNote-style targeted driver communications
 * @module api/campaigns
 */

import { apiRequest } from './core.js';

/**
 * Driver Campaign API - Campaign management, activation, and response tracking
 */
export const campaignAPI = {
  // CRUD operations
  getAll: (params = {}) => {
    const query = new URLSearchParams();
    if (params.tenant_id) query.append('tenant_id', params.tenant_id);
    if (params.org_id) query.append('org_id', params.org_id);
    if (params.status) query.append('status', params.status);
    if (params.campaign_type) query.append('campaign_type', params.campaign_type);
    if (params.limit) query.append('limit', params.limit);
    if (params.offset) query.append('offset', params.offset);

    const queryString = query.toString();
    return apiRequest(`/driver-campaigns${queryString ? '?' + queryString : ''}`);
  },

  getById: (id) => apiRequest(`/driver-campaigns/${id}`),

  create: (campaign) => apiRequest('/driver-campaigns', {
    method: 'POST',
    body: JSON.stringify(campaign),
  }),

  update: (id, updates) => apiRequest(`/driver-campaigns/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  }),

  delete: (id) => apiRequest(`/driver-campaigns/${id}`, {
    method: 'DELETE',
  }),

  // Campaign lifecycle
  activate: (id) => apiRequest(`/driver-campaigns/${id}/activate`, {
    method: 'POST',
  }),

  pause: (id) => apiRequest(`/driver-campaigns/${id}/pause`, {
    method: 'POST',
  }),

  process: (id) => apiRequest(`/driver-campaigns/${id}/process`, {
    method: 'POST',
  }),

  // Response tracking
  getResponses: (id, params = {}) => {
    const query = new URLSearchParams();
    if (params.status) query.append('status', params.status);
    if (params.limit) query.append('limit', params.limit);
    if (params.offset) query.append('offset', params.offset);

    const queryString = query.toString();
    return apiRequest(`/driver-campaigns/${id}/responses${queryString ? '?' + queryString : ''}`);
  },

  recordResponse: (id, response) => apiRequest(`/driver-campaigns/${id}/respond`, {
    method: 'POST',
    body: JSON.stringify(response),
  }),

  markAsRead: (id, driverId) => apiRequest(`/driver-campaigns/${id}/mark-read`, {
    method: 'POST',
    body: JSON.stringify({ driver_id: driverId }),
  }),

  // Statistics
  getStats: (id) => apiRequest(`/driver-campaigns/${id}/stats`),

  // Scheduler
  getDueCampaigns: () => apiRequest('/driver-campaigns/due/process'),
};
